module.exports = __webpack_public_path__ + "static/img/sms-pc.084ae5ab.png";